module.exports = __webpack_public_path__ + "1aeb84b9161a5f9e109766f5bd571fc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing/features/screens/ride/large.png
// module id = 1817
// module chunks = 1